import type { TransferSearchEmptyStateProps } from './index.types';
import React from 'react';
import { EmptyState } from '~/lib/ui/emptyState';
import {
  TRANSFER_SEARCH_EMPTY_STATE_DESCRIPTION,
  TRANSFER_SEARCH_EMPTY_STATE_WITH_NUMBER_DESCRIPTION,
} from './index.constants';

/**
 * Empty state shown when a search yields no contact results.
 *
 * Two variants based on whether the search term is a valid phone number:
 * - With number: "No results found, You can transfer to this exact number, or try to search again"
 * - Without number: "No results found, Please try another search"
 */
export const TransferSearchEmptyState = ({
  showDirectNumberOption,
  testID,
}: TransferSearchEmptyStateProps): React.ReactElement => {
  const componentTestId = testID ? `${testID}-empty-state` : 'empty-state';

  const description = showDirectNumberOption
    ? TRANSFER_SEARCH_EMPTY_STATE_WITH_NUMBER_DESCRIPTION
    : TRANSFER_SEARCH_EMPTY_STATE_DESCRIPTION;

  return (
    <EmptyState
      description={description}
      descriptionClassName="whitespace-pre-line"
      testID={componentTestId}
      className="py-0"
      aria-live="polite"
    />
  );
};

TransferSearchEmptyState.displayName = 'TransferSearchEmptyState';
